<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(function ($) {
  function initCardSwipe() {
    $('.card-media[data-swipe="true"]').each(function () {
      var $el = $(this);

      if ($el.hasClass('slick-initialized')) return;

      // Count only img tags — not card-link
      var imgCount = $el.find('img').length;

      if (imgCount < 1) return;

      $el.slick({
        slide: 'img',
        dots: false,
        arrows: imgCount > 1,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        touchMove: true,
        adaptiveHeight: false,
        prevArrow: '<button class="card-slick-prev" aria-label="Previous"><svg width="5" height="10" viewBox="0 0 15 31" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)"><path fill="#000" d="M1.531 0l12.856 15.32-1.532 1.286L-.001 1.286z"/><path fill="#000" d="M0 29.32L12.856 14l1.532 1.285-12.856 15.32z"/></svg></button>',
        nextArrow: '<button class="card-slick-next" aria-label="Next"><svg width="5" height="10" viewBox="0 0 15 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#000" d="M1.531 0l12.856 15.32-1.532 1.286L-.001 1.286z"/><path fill="#000" d="M0 29.32L12.856 14l1.532 1.285-12.856 15.32z"/></svg></button>',
        appendArrows: $el
      });
    });
  }

  $(document).ready(function () {
    initCardSwipe();
  });

})(jQuery);